import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function useAppLogout(isDirty = false, onDirtyLogout) {
  const navigate = useNavigate();

  const doLogout = useCallback(() => {
    localStorage.clear();
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    const handleAppLogout = () => {
      if (isDirty && onDirtyLogout) {
        onDirtyLogout(); // Only Profile shows popup
      } else {
        doLogout(); // Other pages logout directly
      }
    };

    window.addEventListener("app-logout", handleAppLogout);
    return () => {
      window.removeEventListener("app-logout", handleAppLogout);
    };
  }, [isDirty, onDirtyLogout, doLogout]);
}